import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { Data } from '../../../model/data';

@Component({
  selector: 'app-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.scss']
})
export class ListComponent implements OnInit {

  @Input() data: Data[];

  @Input() enableHoverCursorPointer: boolean;
  @Input() enableEdit: boolean;

  @Output() eeOnSelect: EventEmitter<any> = new EventEmitter();
  @Output() eeOnEdit: EventEmitter<any> = new EventEmitter();

  constructor() {
    this.enableEdit = true;
    this.enableHoverCursorPointer = true;
  }

  ngOnInit() {

  }

  protected onSelect(obj: any) {
    this.eeOnSelect.emit(obj);
  }

  protected onEdit(obj: any) {
    this.eeOnEdit.emit(obj);
  }

}
